import { UrlHelper } from "@/helpers/UrlHelper";
import { CookieHelper } from "@/helpers/CookieHelper";

export const updateTmscCookieAndStore = (store: any, paramNames: string[]): Record<string, string | null> => {
  const tmscCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("tmsc="));
  const tmsc = tmscCookie ? JSON.parse(decodeURIComponent(tmscCookie.split("=")[1])) : {};

  const adsArray = window.location.search.slice(1).split("&");
  const params: Record<string, string | null> = {};

  adsArray.forEach((item) => {
    const [key, value] = item.split("=");
    if (paramNames.includes(key)) {
      const decodedValue = value ? decodeURIComponent(value) : null;
      params[key] = decodedValue;

      tmsc[key] = decodedValue;
    }
  });

  tmsc.adid = UrlHelper.getQueryParam("adid") || tmsc.adid;
  tmsc.affid = UrlHelper.getQueryParam("click_id") ? `clickid:${UrlHelper.getQueryParam("click_id")}` : tmsc.affid;

  for (const key in tmsc) {
    if (undefined === tmsc[key]) {
      delete tmsc[key];
    }
  }

  const cookieDomain = UrlHelper.getCookiesDomainUrl();
  CookieHelper.save("tmsc", encodeURIComponent(JSON.stringify(tmsc)), 3600 * 24 * 30, cookieDomain);

  store.commit("LOAD_TMSC", tmsc);

  return params;
};
